import { DialogMaster } from "#core/components/dialog/Dialog"
import InputNumber from "#core/components/input/number/InputNumber"
import InputSelect from "#core/components/input/select/InputSelect"
import { useApiSend } from "#hooks/useApiSend"
import { Box, TextField } from "@mui/material"
import { EVALUATOR_TYPE_LIST } from "Components/bajas/constants"
import { UseDialogBajaContext } from "Components/bajas/DialogDetailBaja/components/DialogBajaContext"
import { earningsPost } from "Components/bajas/services/api"
import { useState } from "react"
import { toast } from "react-toastify"

const defaultValues = {
	name: "",
	amount: "",
}

export function PerceptionForm({ value, setValue }) {
	return (
		<Box sx={{ display: "grid", gap: 2, mt: 2 }}>
			<TextField
				label="Nombre"
				value={value.name}
				onChange={(e) => setValue({ ...value, name: e.target.value })}
				fullWidth
			/>
			<InputNumber
				label="Cantidad"
				value={value.amount}
				setValue={(e) => setValue({ ...value, amount: e })}
				fullWidth
			/>
			<InputSelect
				options={EVALUATOR_TYPE_LIST}
				optionsLabel="label"
				optionsId="id"
				label={"Tipo"}
				value={value.concept_type}
				setValue={(value) => setValue((old) => ({ ...old, concept_type: value }))}
			/>
		</Box>
	)
}

export default function PerceptionFormDialog({ open, setOpen, refresh }) {
	const { baja } = UseDialogBajaContext()
	const [value, setValue] = useState(defaultValues)
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		// cualquier acción al finalizar
	}
	const { fetch } = useApiSend(earningsPost, { success, end })
	const handleSubmit = () => {
		if (!value.name) {
			toast.error("Se requiere un nombre para la percepción")
			return
		}
		if (!value.amount) {
			toast.error("Se requiere un monto para la percepción")
			return
		}
		setDisabled(true)
		fetch(baja.id, value)
	}
	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				title: "Agregar",
				maxWidth: "xs",
				handleSubmit,
				disabled,
			}}
		>
			<PerceptionForm value={value} setValue={setValue} />
		</DialogMaster>
	)
}
